import React, { useRef } from "react";
import { RicosNodeContextProvider } from "./../../ricos-context/index.js";
import { CELL_AUTO_MIN_WIDTH } from "../consts.js";
import { ROOT } from "../data-hooks.js";
import styles from "../statics/styles/table-viewer-scss.js";
function normalizeColumnWidths(colsMinWidths, colsRelativeWidths) {
  const colsWithDefaults = colsRelativeWidths.map((originalWidth, i) => {
    const minWidth = colsMinWidths[i] || CELL_AUTO_MIN_WIDTH;
    const width = originalWidth < minWidth ? minWidth : originalWidth;
    return {
      width,
      minWidth
    };
  });
  const ratios = colsWithDefaults.map((c) => c.width / c.minWidth);
  const smallestRatio = Math.min(...ratios);
  return colsWithDefaults.map(({ minWidth, width }) => ({
    minWidth,
    width: width / smallestRatio
  }));
}
const Table = ({
  node,
  nodeIndex,
  RicosNodesRenderer,
  NodeViewContainer
}) => {
  const tableRef = useRef(null);
  const { dimensions: { colsMinWidth = [], colsWidthRatio = [] } = {} } = node.tableData || {};
  const colStyles = normalizeColumnWidths(colsMinWidth, colsWidthRatio);
  return /* @__PURE__ */ React.createElement(NodeViewContainer, { node, nodeIndex, withHorizontalScroll: true }, /* @__PURE__ */ React.createElement("div", { ref: tableRef, className: styles.viewMode }, /* @__PURE__ */ React.createElement("table", { className: styles.container, "data-hook": ROOT }, /* @__PURE__ */ React.createElement("colgroup", null, colStyles.map((colStyle, index) => {
    return /* @__PURE__ */ React.createElement("col", { key: index, style: colStyle });
  })), /* @__PURE__ */ React.createElement("tbody", null, /* @__PURE__ */ React.createElement(RicosNodeContextProvider, { parentNode: node, parentIndex: nodeIndex }, /* @__PURE__ */ React.createElement(RicosNodesRenderer, { nodes: node.nodes ?? [] }))))));
};
const TableRenderer = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(Table, { key: node.id, node, ...props });
};
var table_default = TableRenderer;
export {
  table_default as default
};
//# sourceMappingURL=table.js.map

import "@wix/ricos/css/plugin-table-viewer.global.css";